/**
 * Persian/Farsi (FA) UI Translations
 */
import type { UIStrings } from '../types'

export const fa: UIStrings = {
  nav: {
    home: 'خانه',
    about: 'درباره',
    education: 'تحصیلات',
    experience: 'تجربیات',
    projects: 'پروژه‌ها',
    publications: 'انتشارات',
    skills: 'مهارت‌ها',
    languages: 'زبان‌ها',
    certifications: 'گواهینامه‌ها',
    references: 'مراجع',
    contact: 'تماس'
  },
  sections: {
    hero: 'خوش آمدید',
    basics: 'درباره من',
    profiles: 'ارتباط با من',
    education: 'تحصیلات',
    languages: 'زبان‌ها',
    certifications: 'کارگاه‌ها و گواهینامه‌ها',
    skills: 'مهارت‌ها و تخصص',
    experiences: 'تجربیات حرفه‌ای',
    projects: 'پروژه‌ها و نمونه‌کارها',
    publications: 'انتشارات و پژوهش',
    references: 'مراجع',
    contact: 'تماس بگیرید'
  },
  sectionSubtitles: {
    education: 'مسیر تحصیلی و یادگیری مستمر من',
    experiences: 'جدول زمانی نقش‌ها، تحقیقات و مشارکت‌ها',
    projects: 'مجموعه‌ای از پروژه‌های برنامه‌نویسی، بیوانفورماتیک و تحقیقاتی',
    references: 'مراجع حرفه‌ای برای تأیید در دسترس هستند. اطلاعات تماس بنا به درخواست برای استعلام‌های حرفه‌ای معتبر ارائه می‌شود.'
  },
  actions: {
    download_cv: 'دانلود رزومه',
    view_more: 'مشاهده بیشتر',
    view_less: 'مشاهده کمتر',
    contact_me: 'تماس با من',
    send_message: 'ارسال پیام',
    book_call: 'رزرو تماس',
    copy: 'کپی',
    copied: 'کپی شد!',
    close: 'بستن',
    expand: 'گسترش',
    collapse: 'جمع کردن',
    filter: 'فیلتر',
    search: 'جستجو',
    clear: 'پاک کردن',
    get_in_touch: 'تماس بگیرید',
    contact: 'تماس',
    learn_more: 'اطلاعات بیشتر',
    read_more: 'ادامه مطلب',
    show_less: 'کمتر نمایش بده',
    show_phone: 'نمایش تلفن',
    hide_phone: 'مخفی کردن تلفن',
    email: 'ایمیل',
    phone: 'تلفن',
    expand_all: 'گسترش همه',
    collapse_all: 'جمع کردن همه',
    back_to_top: 'بازگشت به بالا',
    retry: 'تلاش مجدد',
    open_pdf: 'باز کردن PDF',
    theme: 'تم',
    show_more: 'نمایش بیشتر',
    show_contact: 'نمایش اطلاعات تماس',
    hide_contact: 'مخفی کردن اطلاعات تماس',
    timeline: 'جدول زمانی',
    by_category: 'بر اساس دسته‌بندی',
    has_link: 'دارای لینک'
  },
  forms: {
    name: 'نام',
    email: 'ایمیل',
    subject: 'موضوع',
    message: 'پیام',
    send: 'ارسال',
    sending: 'در حال ارسال...',
    sent: 'پیام ارسال شد!',
    error: 'خطایی رخ داد',
    success_message: 'از تماس شما متشکرم. در اسرع وقت پاسخ خواهم داد.',
    error_message: 'مشکلی در ارسال پیام شما به وجود آمد. لطفاً بعداً دوباره تلاش کنید یا مستقیماً ایمیل بزنید.',
    contact_description: 'پیام خود را برای من بفرستید و من در اسرع وقت پاسخ خواهم داد',
    demo_notice: 'این یک فرم نمایشی است. برای تماس با من، لطفاً از گزینه‌های ایمیل زیر استفاده کنید.',
    copy_email: 'کپی ایمیل',
    email_copied: 'آدرس ایمیل در کلیپ‌بورد کپی شد!',
    open_email_client: 'باز کردن برنامه ایمیل',
    or: 'یا'
  },
  education: {
    institution: 'موسسه',
    degree: 'مدرک',
    field: 'رشته تحصیلی',
    location: 'موقعیت',
    duration: 'مدت',
    gpa: 'معدل',
    present: 'حال حاضر'
  },
  experience: {
    role: 'نقش',
    institution: 'سازمان',
    duration: 'مدت',
    present: 'حال حاضر',
    responsibilities: 'مسئولیت‌ها',
    focus: 'تمرکز'
  },
  projects: {
    view_project: 'مشاهده پروژه',
    view_code: 'مشاهده کد',
    demo: 'نسخه آزمایشی',
    no_projects: 'پروژه‌ای یافت نشد'
  },
  publications: {
    type: 'نوع',
    status: 'وضعیت',
    published: 'منتشر شده',
    submitted: 'ارسال شده',
    in_review: 'در حال بررسی',
    waiting: 'در انتظار ارسال',
    authors: 'نویسندگان',
    journal: 'مجله',
    year: 'سال',
    doi: 'DOI',
    isbn: 'شابک'
  },
  skills: {
    proficiency: 'مهارت',
    years: 'سال تجربه',
    category: 'دسته',
    all_skills: 'تمام مهارت‌ها',
    skills_across_domains: '{count} مهارت در {domains} حوزه',
    no_skills_matching: 'مهارتی با "{query}" یافت نشد',
    search_placeholder: 'جستجوی مهارت‌ها...',
    more_categories: '+{count} دسته بیشتر',
    skills_count: '{count} مهارت'
  },
  languages_section: {
    language: 'زبان',
    proficiency: 'مهارت',
    native: 'زبان مادری',
    fluent: 'روان',
    professional: 'حرفه‌ای',
    intermediate: 'متوسط',
    beginner: 'مبتدی',
    studying: 'در حال یادگیری',
    certification: 'گواهینامه',
    description: 'مهارت‌های ارتباطی در چند زبان'
  },
  references: {
    available_on_request: 'مراجع در صورت درخواست در دسترس هستند',
    position: 'موقعیت',
    department: 'بخش',
    institution: 'موسسه',
    email: 'ایمیل',
    phone: 'تلفن',
    reference_letter: 'نامه توصیه',
    privacy_notice: 'توجه: اطلاعات تماس به طور پیش‌فرض برای حفظ حریم خصوصی پنهان است. برای مشاهده جزئیات روی "نمایش اطلاعات تماس" کلیک کنید.'
  },
  footer: {
    copyright: '© {year} {name}. تمام حقوق محفوظ است.',
    made_with: 'ساخته شده با',
    built_with: 'ساخته شده با React و TypeScript',
    konami_hint: 'کد کونامی را امتحان کنید 🎮'
  },
  contact: {
    title: 'با من در ارتباط باشید',
    description: 'چه بخواهید پیام بفرستید یا تماس بگیرید، من اینجا هستم تا کمک کنم',
    tab_message: 'ارسال پیام',
    tab_booking: 'رزرو تماس'
  },
  errors: {
    something_went_wrong: 'مشکلی پیش آمد',
    error_occurred: 'خطایی در هنگام بارگذاری برنامه رخ داد',
    error_details: 'جزئیات خطا',
    try_again: 'دوباره تلاش کنید',
    runtime_error: 'این Spark با یک خطای زمان اجرا مواجه شده است',
    unexpected: 'هنگام اجرای برنامه اتفاق غیرمنتظره‌ای رخ داد. جزئیات خطا در زیر نشان داده شده است. با نویسنده Spark تماس بگیرید و او را از این مشکل آگاه کنید.',
    error_details_label: 'جزئیات خطا:'
  },
  filters: {
    all: 'همه',
    programming: 'برنامه‌نویسی',
    bioinformatics: 'بیوانفورماتیک',
    biotechnology: 'زیست‌فناوری',
    academic: 'آکادمیک',
    focus: 'تمرکز'
  },
  domains: {
    programming: 'برنامه‌نویسی',
    bioinformatics: 'بیوانفورماتیک',
    biotechnology: 'زیست‌فناوری',
    academic: 'آکادمیک',
    industry: 'صنعت',
    robotics: 'رباتیک',
    embedded_systems: 'سیستم‌های نهفته',
    student_projects: 'پروژه‌های دانشجویی'
  },
  empty: {
    no_data: 'داده‌ای موجود نیست',
    no_results: 'نتیجه‌ای یافت نشد',
    no_education: 'تحصیلاتی ثبت نشده',
    no_experience: 'تجربه‌ای ثبت نشده',
    no_projects: 'پروژه‌ای ثبت نشده',
    no_publications: 'انتشاراتی ثبت نشده',
    no_skills: 'مهارتی ثبت نشده',
    no_languages: 'زبانی ثبت نشده',
    no_certifications: 'گواهینامه‌ای ثبت نشده',
    no_references: 'مرجعی ثبت نشده',
    no_profile_data: 'اطلاعات پروفایل موجود نیست',
    no_experiences_added: 'هنوز تجربه حرفه‌ای اضافه نشده است.',
    no_experiences_filter: 'هیچ تجربه‌ای با فیلتر تمرکز فعلی مطابقت ندارد. برای مشاهده همه تجربیات "رزومه کامل" را انتخاب کنید.'
  },
  fallbacks: {
    untitled_role: 'نقش بدون عنوان',
    untitled_project: 'پروژه بدون عنوان',
    untitled_publication: 'انتشار بدون عنوان',
    unknown_institution: 'موسسه ناشناخته'
  },
  counts: {
    showing_x_of_y_projects: 'نمایش {current} از {total} پروژه',
    showing_x_of_y_publications: 'نمایش {current} از {total} انتشار{plural}'
  },
  toasts: {
    copied_to_clipboard: '{label} در کلیپ‌بورد کپی شد',
    link_copied: 'لینک {network} در کلیپ‌بورد کپی شد'
  },
  a11y: {
    skip_to_content: 'پرش به محتوای اصلی',
    menu: 'منو',
    close_menu: 'بستن منو',
    select_language: 'انتخاب زبان',
    select_theme: 'انتخاب تم',
    select_focus: 'انتخاب تمرکز',
    open_modal: 'باز کردن مدال',
    close_modal: 'بستن مدال',
    required: 'الزامی',
    scroll_to_top: 'گوشه صفحه - برای اسکرول به بالا کلیک کنید',
    quick_actions: 'اقدامات سریع',
    language_carousel: 'کاروسل انتخاب زبان',
    language_selection: 'انتخاب زبان',
    loading_image: 'بارگذاری تصویر',
    toggle_sidebar: 'تغییر وضعیت نوار کناری',
    pagination: 'صفحه‌بندی',
    previous_page: 'برو به صفحه قبلی',
    next_page: 'برو به صفحه بعدی',
    breadcrumb: 'مسیر صفحه',
    filter_focus: 'فیلتر تمرکز محتوا',
    testimonial_nav: 'ناوبری نظرات',
    media_viewer: 'نمایشگر رسانه',
    previous_media: 'رسانه قبلی',
    next_media: 'رسانه بعدی',
    scroll_to_about: 'اسکرول به بخش درباره',
    certified: 'تایید شده',
    workshop: 'کارگاه',
    search_certifications: 'جستجوی گواهینامه‌ها',
    search_skills: 'جستجوی مهارت‌ها',
    clear_search: 'پاک کردن جستجو',
    list_view: 'نمای لیست',
    carousel_view: 'نمای کاروسل',
    search_publications: 'جستجوی انتشارات',
    visit_profile: 'بازدید از پروفایل {network}',
    page_scroll_progress: 'پیشرفت اسکرول صفحه',
    previous_skill_category: 'دسته مهارت قبلی',
    next_skill_category: 'دسته مهارت بعدی',
    skill_category_nav: 'ناوبری دسته‌های مهارت',
    go_to_slide: 'رفتن به اسلاید {number}',
    close_quick_actions: 'بستن اقدامات سریع',
    open_quick_actions: 'باز کردن اقدامات سریع',
    social_profiles: 'پروفایل‌های شبکه‌های اجتماعی',
    previous_slide: 'اسلاید قبلی',
    next_slide: 'اسلاید بعدی',
    close: 'بستن'
  },
  media: {
    failed_to_load: 'بارگذاری تصویر ناموفق بود',
    image_could_not_load: 'تصویر بارگذاری نشد',
    click_to_open_pdf: 'برای باز کردن در تب جدید کلیک کنید',
    pdf_document: 'سند PDF'
  },
  profiles: {
    right_click_to_copy: 'راست‌کلیک برای کپی لینک',
    no_profiles: 'پروفایلی موجود نیست'
  },
  booking: {
    title: 'رزرو تماس',
    description: 'نوع جلسه مورد نظر خود را انتخاب کرده و زمان مناسب را برگزینید',
    meeting_type: 'نوع جلسه',
    video_call: 'تماس تصویری',
    phone_call: 'تماس تلفنی',
    in_person: 'حضوری',
    video_description: 'جلسه از طریق Zoom، Google Meet یا Microsoft Teams',
    phone_description: 'مکالمه مستقیم تلفنی',
    in_person_description: 'ملاقات در محل مشخص شده',
    select_date: 'انتخاب تاریخ',
    select_time: 'انتخاب زمان',
    book_call: 'رزرو تماس',
    booking: 'در حال رزرو...',
    clear_selection: 'پاک کردن انتخاب',
    your_selection: 'انتخاب شما:',
    success_title: 'تماس رزرو شد!',
    success_description: '{type} شما برای {date} در ساعت {time} برنامه‌ریزی شد.',
    error_title: 'رزرو ناموفق',
    error_description: 'مشکلی در رزرو تماس شما به وجود آمد. لطفاً بعداً دوباره تلاش کنید.',
    select_date_time: 'لطفاً یک تاریخ و زمان انتخاب کنید',
    selection_cleared: 'انتخاب پاک شد',
    unavailable: 'غیر قابل دسترس',
    demo_notice: 'این یک رابط رزرو نمایشی است. برای رزرو جلسه واقعی، لطفاً از لینک زیر استفاده کنید.',
    schedule_external: 'رزرو از طریق Calendly',
    calendly_cta: 'باز کردن صفحه رزرو',
    external_link_notice: 'شما به یک سرویس رزرو خارجی هدایت خواهید شد.'
  },
  validation: {
    required: '{field} الزامی است',
    invalid_email: 'لطفاً یک آدرس ایمیل معتبر وارد کنید',
    min_length_2: '{field} باید حداقل ۲ کاراکتر باشد',
    min_length_3: '{field} باید حداقل ۳ کاراکتر باشد',
    min_length_10: '{field} باید حداقل ۱۰ کاراکتر باشد'
  },
  loading: {
    loading: 'در حال بارگذاری...',
    please_wait: 'لطفاً صبر کنید'
  },
  pwa: {
    install_app: 'نصب برنامه',
    installed: 'برنامه نصب شده',
    offline_mode: 'آفلاین هستید',
    update_available: 'به‌روزرسانی موجود است',
    update_now: 'الان به‌روز کنید'
  },
  download: {
    title: 'دانلود رزومه',
    description: 'فرمت مورد نظر خود را انتخاب کرده و محتوا را سفارشی کنید',
    format: 'فرمت',
    pdf_browser: 'PDF (چاپ مرورگر)',
    pdf_browser_desc: 'از گفتگوی چاپ مرورگر برای ذخیره به عنوان PDF استفاده کنید',
    json_export: 'خروجی JSON',
    json_export_desc: 'داده‌های خام در فرمت JSON',
    markdown: 'Markdown',
    markdown_desc: 'فرمت متن ساده خوانا',
    sections: 'بخش‌های مورد نظر',
    select_all: 'انتخاب همه',
    deselect_all: 'لغو انتخاب همه',
    include_contact: 'شامل اطلاعات تماس',
    include_references: 'شامل مراجع',
    preview: 'پیش‌نمایش',
    download: 'دانلود',
    downloading: 'در حال دانلود...',
    success: 'دانلود کامل شد',
    error: 'دانلود ناموفق'
  },
  articles: {
    title: 'مقالات و وبلاگ',
    featured: 'ویژه',
    read_time: '{minutes} دقیقه مطالعه',
    external_link: 'مقاله خارجی',
    no_articles: 'مقاله‌ای موجود نیست',
    filter_by_tag: 'فیلتر بر اساس تگ',
    all_tags: 'همه'
  },
  video: {
    play: 'پخش ویدیو',
    pause: 'توقف ویدیو',
    mute: 'بی‌صدا',
    unmute: 'صدادار',
    fullscreen: 'تمام صفحه',
    exit_fullscreen: 'خروج از تمام صفحه',
    loading: 'در حال بارگذاری ویدیو...'
  },
  accessibility: {
    high_contrast: 'حالت کنتراست بالا',
    font_size: 'اندازه فونت',
    increase_font: 'افزایش اندازه فونت',
    decrease_font: 'کاهش اندازه فونت',
    reset_font: 'بازنشانی اندازه فونت',
    dyslexia_font: 'فونت مناسب دیسلکسی',
    reduced_motion: 'حرکت کمتر'
  },
  caseStudy: {
    viewCaseStudy: 'مشاهده مطالعه موردی',
    collapse: 'جمع کردن',
    problem: 'مسئله',
    solution: 'راه‌حل',
    process: 'فرآیند',
    results: 'نتایج',
    technologies: 'فناوری‌ها',
    gallery: 'گالری',
    links: 'لینک‌ها',
    metrics: 'معیارهای کلیدی',
    viewProject: 'مشاهده پروژه',
    viewCode: 'مشاهده کد',
    liveDemo: 'نسخه آزمایشی',
    close: 'بستن',
    of: 'از',
    previous: 'تصویر قبلی',
    next: 'تصویر بعدی'
  },
  cookies: {
    title: 'رضایت کوکی',
    message: 'ما از کوکی‌ها برای تحلیل ترافیک سایت و بهبود تجربه شما استفاده می‌کنیم. شما می‌توانید هر زمان انصراف دهید.',
    accept: 'پذیرفتن',
    decline: 'رد کردن',
    dntMessage: 'ما تشخیص دادیم که شما Do Not Track را فعال کرده‌اید. ردیابی تحلیلی غیرفعال است.',
    privacyPolicy: 'سیاست حفظ حریم خصوصی',
    close: 'بستن'
  },
  testimonials: {
    title: 'توصیه‌ها و نظرات',
    subtitle: 'نظر همکاران و مشتریان',
    linkedIn: 'مشاهده در لینکدین',
    noTestimonials: 'توصیه‌ای موجود نیست',
    previous: 'توصیه قبلی',
    next: 'توصیه بعدی',
    pause: 'توقف چرخش خودکار',
    play: 'ادامه چرخش خودکار',
    of: 'از'
  },
  seo: {
    name: 'رامین یزدانی',
    title: 'زیست‌فناور و توسعه‌دهنده',
    description: 'رزومه رامین یزدانی - زیست‌فناور و توسعه‌دهنده نرم‌افزار',
    separator: ' - '
  }
}
